module.exports = __webpack_public_path__ + "static/media/Chop Suey.64e9d057.svg";